import React from 'react';
import { Table, Tag } from 'antd';
import styled from 'styled-components';

const StyledTag = styled(Tag)`
  cursor: initial !important;
`;

const LineItemAppList = ({ alcoholTypes, list, columns }) => [
  <div>
    <p>
      Targeting apps with:{' '}
      {alcoholTypes.map(a => (
        <StyledTag color="blue">{a}</StyledTag>
      ))}
    </p>
  </div>,
  <Table pagination={false} rowKey="id" dataSource={list} columns={columns} />,
];

LineItemAppList.defaultProps = {};

LineItemAppList.propTypes = {};

export default LineItemAppList;
